import { useEffect, useState, useMemo } from 'react';
import { useParams, useLocation } from 'react-router-dom';

// hooks
import useTable from '../../hooks/useTable';

// API
import conObj from '../../utils/connection-assistant';

export default function useLoadOnScroll(selectedCateg, companyId = null) {
  const params = useParams();

  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);

  const [error, setError] = useState(false);
  const [total, setTotal] = useState(0);

  const [gameList, setGameList] = useState([]);

  const [companyName, setCompanyName] = useState('');

  const { page, setPage } = useTable(0);

  const [search, setSearch] = useState('');

  const [sort, setSort] = useState('');

  const hasMore = useMemo(() => {
    if (Number(total) === gameList?.length) return false;
    return true;
  }, [total, gameList]);

  useEffect(() => {
    setGameList([]);
    setPage(1);
    setTotal(0);
  }, [selectedCateg, companyId, location.state?.parentKey]);

  useEffect(() => {
    if (!selectedCateg) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(false);

    let url = `games/items${selectedCateg ? `/${selectedCateg}` : ''}.json?${
      (params?.companyId || companyId) && !search ? `company_id=${params?.companyId || companyId}` : ''
    }`;

    if (location.state?.parentKey || location.state?.companyId === 'all') {
      url = `games/items.json?parent_key=${location.state?.parentKey}`;
    }

    if (location.state?.gameUrl) {
      url = location.state?.gameUrl;
    }

    let totalGames = 0;

    conObj
      .post(`${url}&page=${page}&limit=30${search ? `&search=${search}` : ''}${sort ? `&sort=${sort}` : ''}`)
      .then((response) => {
        const games = response?.data?.data?.data || [];
        totalGames = response?.data?.data?.page?.total_data || 0;
        setTotal(totalGames);
        if (page === 0 && games.length > 0) {
          setCompanyName(games[0].company_name || '');
        }

        // load more, and add it to previous fetched data
        if (page > 0) {
          setGameList((prev) => [...prev, ...response.data?.data?.data]);
        } else {
          // load first page
          setGameList(response.data?.data?.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        if (page === 0 && totalGames >= 30) {
          setTimeout(() => setIsLoading(false), 500); // this is too not trigger infinite scroll refresh on first page
        } else setIsLoading(false);
      });
  }, [
    selectedCateg,
    companyId,
    page,
    search,
    sort,
    params.companyId,
    location.state?.parentKey,
    location.state?.gameUrl,
  ]);

  const handleSort = (value) => {
    setPage(0);
    setSort(value);
  };

  return {
    isLoading,
    error,
    companyName,
    gameList,
    setGameList,
    hasMore,
    handleSort,
    search,
    setSearch,
    sort,
    setSort,
    page,
    setPage,
  };
}
